import { render, staticRenderFns } from "./permittings.vue?vue&type=template&id=6acaf5e5"
import script from "./permittings.vue?vue&type=script&lang=js"
export * from "./permittings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports